import React, { useEffect, useState } from 'react'
import { Banner, Button } from '@arnsbogroup/react-voicearchive'
import useValidate, { is } from '@arnsbogroup/react-voicearchive/hooks/useValidate'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from "./messages";


const RequiredFields = ( { supplier, reFetchSupplier} ) => {

    const [missingField, setMissingFields] = useState([])
    const [loading, setLoading] = useState(false)
    const { formatMessage } = useIntl()

    if (!supplier) {
        return null
    }

    const [validations, validate] = useValidate(supplier, {
        firstname: [is.present],
        lastname: [is.present],
        gender: [is.present],
        email: [is.present, is.email]
    })
    
    const fields = [
        {
            label: 'First name',
            rule: () => validate(['firstname'])
        },
        {
            label: 'Last name',
            rule: () => validate(['lastname'])
        },
        {
            label: 'Gender',
            rule: () => validate(['gender'])
        },
        {
            label: 'Email',
            rule: () => validate(['email'])
        },
        {
            label: 'Native Language',
            rule: () => validate(['languages']) && supplier.languages.filter((language) => language.skill_set_id == 1).length
        }
    ]

    useEffect(() => {
        setMissingFields(
            fields
                .filter((field) => !field.rule())
                .map((field) => field.label)
        )
    }, [supplier])

    const completeSupplier = () => {
        setLoading(true)
        fetch(`/rest/v2/supplier/${supplier.uid}/complete-setup`, {
            method: 'POST',
            body: supplier
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.success) {
                toastr.success('Setup completed.')
                reFetchSupplier(supplier.uid)
            } else {
                toastr.error(response.errors)
            }
            setLoading(false)
        }).catch((error) => {
            toastr.error(error)
            setLoading(false)
        })
    }

    if (supplier.contact) {
        return null
    }

    return (
        <div className="p-4 text-center flex flex-col md:flex-row">
            <Banner
                title={formatMessage(missingField.length ? messages.incompleteTitle : messages.completeTitle)}
                subtitle={missingField.length ? missingField.join(', ') : formatMessage(messages.completeSubTitle)}
                state={missingField.length ? "warning" : "success"}
            >
                <Button 
                    onClick={() => completeSupplier()}
                    disabled={loading || missingField.length}
                    icon={['fa', loading ? 'spinner-third' : 'save']}
                    state={missingField.length ? 'warning' : 'positive'}
                    className={missingField.length ? "bg-warning" : "bg-positive"}
                >
                    <FormattedMessage {...messages.completeSupplier} />
                </Button>
                
            </Banner>
        </div>
    )
}

export default RequiredFields
